<template>
    <div class="create-lottery">
        <h1>三站认证</h1>

        <form @submit.prevent="submitForm">
            <table class="form-table">
                <tbody>
                    <!-- 基本设置 -->
                    <tr>
                        <th colspan="2">请提交最大的站点URL并调低隐私</th>
                    </tr>

                    <tr>
                        <td><label>邮箱 (三站一致)</label></td>
                        <td><el-input v-model="form.email" /></td>
                    </tr>

                    <tr>
                        <td><label>站点1</label></td>
                        <td><el-input v-model="form.siteOne" /></td>
                    </tr>
                    <tr>
                        <td><label>站点2</label></td>
                        <td><el-input v-model="form.siteTwo" /></td>
                    </tr>
                    <tr>
                        <td><label>站点3</label></td>
                        <td><el-input v-model="form.siteThree" /></td>
                    </tr>

                    <!-- <tr>
                        <td colspan="2" style="text-align:center">
                            <el-button type="primary" native-type="submit">提 交</el-button>
                        </td>
                    </tr> -->
                </tbody>
            </table>
        </form>

        <pre class="preview">
      {{ form }}
    </pre>
    </div>
</template>

<script setup>
import { reactive, onMounted } from 'vue'
const tg = window.Telegram?.WebApp || ''

const form = reactive({
    userId: null,
    username: '',
    firstName: '',
    lastName: '',

    email: '',
    siteOne: '',
    siteTwo: '',
    siteThree: '',
    warn: ''
})

onMounted(() => {
    if (tg) {
        tg.ready() // 等 WebApp 初始化完成
        if (tg.initDataUnsafe?.user) {
            const user = tg.initDataUnsafe.user
            form.userId = user.id
            form.username = user.username || ''
            form.firstName = user.first_name || ''
            form.lastName = user.last_name || ''

            tg.MainButton.setText("提 交")
            tg.MainButton.show()

            tg.MainButton.onClick(() => {
                form.warn = '正在发送数据'
                tg.sendData(JSON.stringify(form))
            })

        } else {
            console.warn('用户信息不存在，确保从 Telegram 打开 Web App')
            form.warn = '用户信息不存在，确保从 Telegram 打开 Web App'
        }
    } else {
        console.warn('tg 未定义，可能不是从 Telegram 打开')
        form.warn = 'tg 未定义，可能不是从 Telegram 打开'
    }
})

const submitForm = () => {
    console.log('提交数据:', form)
    alert('抽奖创建成功！')
}
</script>

<style scoped>
.form-table td {
    padding: 8px;
    border: 1px solid #ddd;
    text-align: left;
    /* 左对齐所有单元格 */
    vertical-align: middle;
    /* 垂直居中，看起来整齐 */
}

.form-table td:first-child {
    width: 35%;
    /* 左列宽 */
    text-align: right;
    /* label 靠右对齐更整齐 */
    padding-right: 10px;
}

.form-table td:last-child {
    width: 65%;
    /* 右列宽 */
    text-align: left;
}

/* 针对表单内的 checkbox */
.create-lottery :deep(.el-checkbox) {
    margin-right: 10px;
    /* 右边间距 */
    vertical-align: middle;
    /* 可选，垂直居中 */
}

.create-lottery {
    max-width: 500px;
    margin: auto;
}

.form-table {
    width: 100%;
    border-collapse: collapse;

}

.form-table td,
.form-table th {
    padding: 8px;
    border: 1px solid #ddd;

}

.form-table th {
    background: #f0f0f0;
    text-align: left;
}
</style>
